module.exports = __webpack_public_path__ + "static/paletaMockup-0ab0be7917e23d607d841d871a456ef5.png";